import { render, staticRenderFns } from "./QuoteView.vue?vue&type=template&id=3b814a70&"
import script from "./QuoteView.vue?vue&type=script&lang=js&"
export * from "./QuoteView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports